export default '/build/84545311.svg'